import { isServer } from '@/shared/util/ssr';
import { StorageType } from '@/shared/constant/StorageType';

const storage: Record<string, string> = {};

export default function getCompatibleLocalStorage(storageType: StorageType) {
  return !isServer
    ? storageType === StorageType.LocalStorage
      ? localStorage
      : {
        getItem: (key: string) => {
          return storage.hasOwnProperty(key) ? storage[key] : null;
        },
        setItem: (key: string, value: string) => {
          storage[key] = value;
        },
        removeItem: (key: string) => {
          delete storage[key];
        }
      }
    : {
        getItem: () => undefined,
        setItem: () => undefined,
        removeItem: () => undefined,
      };
}
